import React from 'react';
import styled, {css} from 'styled-components';

const Nosotros = ({ viewNosotros}) => {
    return(
        <NosotrosCSS viewNosotros = { viewNosotros}>
            <h1>INVIERTABIEN S.A.S</h1>
            <h2>Brindamos desarrollo, fortalecimiento y apoyo al turismo regional y nacional, mediante 
            la creación,    planeación y construcción de GLAMPING como metodo de ingresos para todos los propietarios de Parcelas 
            en el Club Ecoturístico Flor del Guaviare.<br></br><br></br>Somos Promotores del Turismo a Nivel Nacional 
            y defensores del medio ambiente, por eso Ofrecemos esta oportunidad de pertenecer a este negocio rentable y contribuir 
            a la conservación del medio ambiente y hacer crecer tu patrimonio.</h2>
        </NosotrosCSS>
    )
}
export default Nosotros;

const NosotrosCSS = styled.div`
    position: relative;
    top: 12%;
    z-index: 5;
    height: 88%;
    background-color: #fff;
    display: none;
    ${props => props.viewNosotros === true && css`
        display: block;
    `}
    ${props => props.viewNosotros === false && css`
        display: none;
    `}
    @media(max-width:1150px) {
        height:90%;
    }
    @media(max-width:1024px) {
        height:110%;
    }
    @media(max-width:768px) {
        height:120%;
    }
    @media(max-width:600px) {
        height:130%;
    }
    @media(max-width:410px) {
        height:210%;
    }
    @media(max-width:320px) {
        height:210%;
    }
    h1 {
        margin:4%;
        font-family: widen latin;
        font-size: 250%;
    }
    h2 {
        font-family: widen latin;
        font-size: 200%;
        margin: 4%;
    }
`;